/**
 * CommunicationTab — extracted from EmployeeCreate.js.
 * Receives state + handlers via `ctx` prop bag.
 */
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/ui/select';
import { Button } from '../../../../components/ui/button';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Textarea } from '../../../../components/ui/textarea';
import { TabsContent } from '../../../../components/ui/tabs';
import { Badge } from '../../../../components/ui/badge';
import { Plus, Trash2, User, Building2, Briefcase, Mail, Phone, Home, CreditCard, FileText, GraduationCap, Clock, DollarSign, Users, Heart, Calendar, Wallet, RefreshCw } from 'lucide-react';

const CommunicationTab = ({ ctx }) => {
  const {
    formData,
    handleCommChange,
  } = ctx;

  return (
          <TabsContent value="communication">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Phone className="w-5 h-5 text-stone-700" />
                  Communication (Infotype 0105)
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label>Work Email</Label>
                    <Input
                      type="email"
                      value={formData.communication.work_email}
                      onChange={(e) => handleCommChange('work_email', e.target.value)}
                      placeholder="john.doe@company.com"
                    />
                  </div>
                  <div>
                    <Label>Personal Email</Label>
                    <Input
                      type="email"
                      value={formData.communication.personal_email}
                      onChange={(e) => handleCommChange('personal_email', e.target.value)}
                      placeholder="john.doe@gmail.com"
                    />
                  </div>
                  <div>
                    <Label>Work Phone</Label>
                    <Input
                      value={formData.communication.work_phone}
                      onChange={(e) => handleCommChange('work_phone', e.target.value)}
                      placeholder="+91-XXX-XXXXXXX"
                    />
                  </div>
                  <div>
                    <Label>Mobile Phone</Label>
                    <Input
                      value={formData.communication.mobile_phone}
                      onChange={(e) => handleCommChange('mobile_phone', e.target.value)}
                      placeholder="+91-XXXXXXXXXX"
                    />
                  </div>
                  <div className="col-span-2 border-t pt-4 mt-2">
                    <h4 className="font-medium mb-3">Emergency Contact</h4>
                    <div className="grid grid-cols-3 gap-4">
                      <div>
                        <Label>Contact Name</Label>
                        <Input
                          value={formData.communication.emergency_contact_name}
                          onChange={(e) => handleCommChange('emergency_contact_name', e.target.value)}
                          placeholder="Jane Doe"
                        />
                      </div>
                      <div>
                        <Label>Contact Phone</Label>
                        <Input
                          value={formData.communication.emergency_contact_phone}
                          onChange={(e) => handleCommChange('emergency_contact_phone', e.target.value)}
                          placeholder="+91-XXXXXXXXXX"
                        />
                      </div>
                      <div>
                        <Label>Relationship</Label>
                        <Input
                          value={formData.communication.emergency_contact_relation}
                          onChange={(e) => handleCommChange('emergency_contact_relation', e.target.value)}
                          placeholder="Spouse"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
  );
};

export default CommunicationTab;
